<div class="grid">
    <div class="col-12">
        <div class="card">
            
            <p-toast key="lista"></p-toast>
            <p-toolbar styleClass="mb-0">
                <ng-template pTemplate="left">
                    <div class="my-2">
                        <button *ngIf="crear" pButton pRipple label="Nuevo" icon="pi pi-plus" class="mr-2" (click)="onCreate()"></button>
                        <!-- <button pButton pRipple label="Eliminar" icon="pi pi-trash" class="p-button-danger mr-2" (click)="onDelete()" [disabled]="!selectedItems || !selectedItems.length"></button> -->
                        <!-- <button *ngIf="importar" pButton pRipple label="Importar" icon="pi pi-cloud-upload" class="p-button-info mr-2" (click)="input.click()"></button> -->
                        <p-splitButton *ngIf="importar" styleClass="p-button-info mr-2" label="Importar" icon="pi pi-cloud-upload" (onClick)="input.click()" [model]="importItems"></p-splitButton>
                        <input #input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display: none;" (change)="onImport($event)">
                        <!-- <p-fileUpload mode="basic" name="demo[]" accept="*" maxFileSize="10000000" (onUpload)="onImport($event)"></p-fileUpload> -->
                        <button *ngIf="exportar" pButton pRipple label="Exportar" icon="pi pi-cloud-download" class="p-button-info mr-2" (click)="onExport()"></button>
                    </div>
                </ng-template>
                
                <ng-template pTemplate="right">
                    <button pButton pRipple label="Filtros" icon="pi pi-filter" class="p-button-help" (click)="showDialog()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt styleClass="p-datatable-sm p-datatable-gridlines"
                [value]="items" [columns]="columns" responsiveLayout="scroll" [rows]="10" [paginator]="true" [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
                [lazy]="true" sortMode="multiple" [stateKey]="recordName" [loading]="loading" [totalRecords]="totalRecords" [showLoader]="false"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [(selection)]="selectedItems" selectionMode="multiple" [rowHover]="true"
                (onLazyLoad)="onItems($event)">
                
                <ng-template pTemplate="caption">
                    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 class="m-0">Lista de {{ pluralName }}</h5>
                        <span class="block mt-2 md:mt-0 p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input [(ngModel)]="filterValue" pInputText type="text" placeholder="Buscar..." 
                                (keydown.enter)="filterData($event.target)"
                                (focusout)="filterData($event.target, true)"
                                (input)="onChangeBuscar()"/>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th> -->
                        <ng-container *ngFor="let col of columns">
                            <th  *ngIf="!col.hidden" class="align-center cabecera" [pSortableColumn]="col.field">{{ col.label }} <p-sortIcon [field]="col.field"></p-sortIcon></th>
                        </ng-container>
                    </tr>                   
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr (click)="onEdit(item)" [ngClass]="{'custom-row': fieldRowStatus && item[fieldRowStatus] === fieldRowStatusValue}">
                        <!-- <td>
                            <p-tableCheckbox [value]="item"></p-tableCheckbox>
                        </td> -->
                        <ng-container *ngFor="let col of columns">
                            <ng-container *ngIf="!col.hidden">
                                <td *ngIf="loading">
                                    <p-skeleton borderRadius="1rem"></p-skeleton>
                                </td>
                                <ng-container *ngIf="!loading">
                                    <td *ngIf="col.type === 'id'" style="width:8%; min-width:8rem;">
                                        <div class="flex justify-content-end">{{ item[col.field] }}</div>
                                    </td>
                                    <td *ngIf="col.type === 'text'">
                                        {{ item[col.field] }}
                                    </td>
                                    <td *ngIf="col.type === 'number'">
                                        <div class="flex justify-content-end">{{ item[col.field] | currency: '': '': '0.0-0': 'es-PY' }}</div>
                                    </td>
                                    <ng-container *ngIf="col.type === 'boolean'">
                                        <td *ngIf="item[col.field] === true">
                                            <div class="flex justify-content-center">
                                                <i class="pi pi-check-circle" style="color: green; font-size: 1.5rem;"></i>
                                            </div>
                                        </td>
                                        <td *ngIf="item[col.field] === false">
                                            <div class="flex justify-content-center">
                                                <i class="pi pi-times-circle" style="color: red; font-size: 1.5rem;"></i>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <td *ngIf="col.type === 'date'">
                                        {{ item[col.field] | date: 'dd/MM/yyyy' }}
                                    </td>
                                    <td *ngIf="col.type === 'datetime'">
                                        {{ item[col.field] | date: 'dd/MM/yyyy HH:mm:ss' }}
                                    </td>
                                    <td *ngIf="col.type === 'multiselect'" style="width: 8%;" class="align-center">
                                        <span *ngIf="!getBGValue(col.options, item[col.field])" [class]="'custom-badge status-qualified'">{{ getOptionLabel(col.options, item[col.field] ) }}</span>
                                        <span *ngIf="getBGValue(col.options, item[col.field])" [class]="'custom-badge status-unqualified'">{{ getOptionLabel(col.options, item[col.field] ) }}</span>
                                    </td>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        <!-- <td>
                            <div class="flex">
                                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" (click)="edititem(item)"></button>
                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteitem(item)"></button>
                            </div>
                        </td> -->
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </div>
</div>
<p-dialog [visible]="cargando" [style]="{minWidth: '12vw'}" [modal]="true" [closable]="false" appendTo="body">
    <div class="flex justify-content-center flex-wrap">
        <p-progressSpinner></p-progressSpinner>
    </div>
</p-dialog>
<p-dialog header="Filtros" position="top" [(visible)]="display" [modal]="false" [responsive]="true" [style]="{maxWidth: '50rem'}">
    <form *ngIf="dialogFG" [formGroup]="dialogFG">
        <div class="grid">
            <ng-container *ngFor="let col of columns">
                <div *ngIf="col.type==='id'" class="col-12 md:col-4">
    				<!-- <label [htmlFor]="col.field">{{ col.label }}</label> -->
                    <p-inputNumber [placeholder]="col.label" mode="decimal" [formControlName]="col.field"></p-inputNumber>
                </div>
                <div *ngIf="col.type==='number'" class="col-12 md:col-4">
                    <p-inputNumber [placeholder]="col.label" mode="decimal" [formControlName]="col.field"></p-inputNumber>
                    <!-- <app-number-input [label]="col.header" [control]="dialogFG.get(col.field)!"></app-number-input> -->
                </div>
                <div *ngIf="col.type==='text'" class="col-12 md:col-4">
                    <input [placeholder]="col.label" type="text" pInputText [formControlName]="col.field">
                </div>
                <div *ngIf="col.type === 'ref'" class="col-12 md:col-4">
                    <input [placeholder]="col.label" type="text" pInputText [formControlName]="col.field">
                </div>
                <div *ngIf="col.type==='boolean'" class="col-12 md:col-4">
                    <!-- <app-tri-boolean-input [label]="col.header" [control]="dialogFG.get(col.field)!"></app-tri-boolean-input> -->
                    <div class="field-checkbox">
                        <p-triStateCheckbox [id]="col.field" [name]="col.field" [value]="col.label" [formControlName]="col.field"></p-triStateCheckbox>
                        <label [for]="col.field">{{ col.label }}</label>
                    </div>
                </div>
                <div *ngIf="col.type==='multiselect'" class="col-12 md:col-4">
                    <!-- <app-select-input [label]="col.header" [control]="dialogFG.get(col.field)!" [options]="col.options!"></app-select-input> -->
                    <p-multiSelect appendTo="body" [options]="col.options" [formControlName]="col.field" [defaultLabel]="col.label" optionLabel="nombre" optionValue="valor" >
                        
                    </p-multiSelect>
                </div>
                <ng-container *ngIf="col.type==='date'">
                    <div class="col-12 md:col-4">
                        <p-calendar placeholder="{{ col.label }} - Desde" appendTo="body" formControlName="desde_{{ col.field }}" [showIcon]="true" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="col-12 md:col-4">
                        <p-calendar placeholder="{{ col.label }} - Hasta" appendTo="body" formControlName="hasta_{{ col.field }}" [showIcon]="true" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </ng-container>
                <ng-container *ngIf="col.type==='datetime'">
                    <div class="col-12 md:col-4">
                        <p-calendar placeholder="{{ col.label }} - Desde" appendTo="body" formControlName="desde_{{ col.field }}" [showIcon]="true" dateFormat="dd/mm/yy"
                            showTime="true" [hourFormat]="24"></p-calendar>
                    </div>
                    <div class="col-12 md:col-4">
                        <p-calendar placeholder="{{ col.label }} - Hasta" appendTo="body" formControlName="hasta_{{ col.field }}" [showIcon]="true" dateFormat="dd/mm/yy"
                            showTime="true" [hourFormat]="24"></p-calendar>
                    </div>
                </ng-container>
                
            </ng-container>
        </div>
    </form>
    <p-footer>
        <div class="row footer-btn">
            <button pButton class="p-button-outlined" type="button" label="Limpiar" icon="pi pi-ban" (click)="limpiarFiltro()"></button>
            <button pButton type="button" label="Aplicar" icon="pi pi-check-circle" (click)="aplicarFiltro()"></button>
        </div>
    </p-footer>
</p-dialog>